import { Field, FieldProps } from "formik";

import {
  FormControlLabel,
  FormControlLabelProps,
  Switch,
  SwitchProps,
  FormHelperText
} from "@material-ui/core";

export default function FormikSwitchField({
  name,
  label,
  helperText,
  labelProps,
  switchProps
}: SwitchProps & {
  name: string;
  label: string;
  helperText?: string;
  labelProps?: FormControlLabelProps;
  switchProps?: SwitchProps;
}): JSX.Element {
  return (
    <Field name={name}>
      {({ meta, form }: FieldProps) => (
        <>
          <FormControlLabel
            control={
              <Switch
                color={
                  meta.error ? "secondary" : (switchProps?.color ?? "primary")
                }
                checked={!!meta.value}
                onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                  form.setFieldValue(name, evt.target.checked)
                }
                {...switchProps}
              />
            }
            label={label}
            {...labelProps}
          />
          {/* Show the error in place of the helper text while there is one. */}
          {meta.error ? (
            <FormHelperText error>{meta.error}</FormHelperText>
          ) : helperText ? (
            <FormHelperText>{helperText}</FormHelperText>
          ) : null}
        </>
      )}
    </Field>
  );
}
